// extracted by mini-css-extract-plugin
export default {"wrapper":"Partners-module--wrapper--HWkZf","title":"Partners-module--title--2c5LS","slider":"Partners-module--slider--q1fke","slide":"Partners-module--slide--3_sjD"};